import React, { useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Collapse from '@material-ui/core/Collapse';
import Button from '@material-ui/core/Button';
import PlayIcon from '@material-ui/icons/PlayArrow';
import AddIcon from '@material-ui/icons/AddCircle';
import RemoveIcon from '@material-ui/icons/RemoveCircle';
import ShareIcon from '@material-ui/icons/Share';

const useStyles = makeStyles(theme => ({
  root: {

  },
  background: {
    backgroundColor: '#cca',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
  },
  content: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(3),
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(3),
  },
  collapse: {
    margin: theme.spacing(3)
  },
  container1: {
    minHeight: '172px'
  },
  container2: {
    minHeight: '136px'
  },
  title: {
    color: theme.palette.primary.main,
  },
  subtitle: {
    marginTop: theme.spacing(1) / 2,
    marginBottom: theme.spacing(1),
    textTransform: 'uppercase'
  },
  time: {
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    fontWeight: 600,
    marginTop: theme.spacing(1) /2,
    marginBottom: theme.spacing(2)
  },
  description: {
    fontSize: '12px',
    margin: 0,
    marginBottom: theme.spacing(2),
    whiteSpace: 'pre-line'
  },
  li: {
    fontSize: '12px',
  },
  button: {
    textTransform: 'none',
    marginLeft: -theme.spacing(1),
  },
}));

const Finalists = (props) => {
  const classes = useStyles();
  return (
    <>
      <h5>{props.config.name}</h5>
      <ul>
        {props.config.values.map((value, index) => (
          <li className={classes.li} key={index}>{value}</li>
        ))}
      </ul>
    </>
  );
};

export default (props) => {
  const [isOpen, setOpen] = useState(false);
  const classes = useStyles();
  const handleShare = (url) => {
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${url}`, '_blank', 'width=600, height=600, resizable=yes, scrollbars=yes');
  };
  return (
    <Paper className={classes.root}>
      <Grid container>
        <Grid item sm={5} xs={12} className={classes.background} style={{ backgroundImage: `url("${props.config.imageUrl}")` }}></Grid>
        <Grid item sm={7} xs={12}>
          <div className={classes.content}>
            <div className={classes.container1}>
              <div className={classes.container2}>
                <Grid container justify="space-between">
                  <Grid item>
                    <div><h4 className={classes.title}>{props.config.title}</h4></div>
                    {props.config.subtitle &&
                      <div><h6 className={classes.subtitle}>{props.config.subtitle}</h6></div>
                    }
                    {props.config.time &&
                      <div><h5 className={classes.time}>{props.config.time}</h5></div>
                    }
                  </Grid>
                  <Grid item>
                    {props.config.timecode &&
                      <Button color="default" variant="contained" size="small" disableElevation className={classes.button} startIcon={<PlayIcon />} onClick={() => props.setCurrentTime(props.config.timecode)}> play </Button>
                    }
                  </Grid>
                </Grid>
                <div><p className={classes.description}>{props.config.description}</p></div>
              </div>
              <Grid container justify="space-between">
                <Grid item>
                  {props.config.finalists &&
                    <>
                      {!isOpen &&
                        <Button color="primary" size="small" className={classes.button} startIcon={<AddIcon />} onClick={() => setOpen(!isOpen)} > show finalists </Button>
                      }
                      {isOpen &&
                        <Button color="primary" size="small" className={classes.button} startIcon={<RemoveIcon />} onClick={() => setOpen(!isOpen)} > hide finalists </Button>
                      }
                    </>
                  }
                </Grid>
                <Grid item>
                  {props.config.shareUrl &&
                    // <Button color="primary" variant="contained" size="small" disableElevation className={classes.button} startIcon={<ShareIcon />} href={`https://www.linkedin.com/sharing/share-offsite/?url=${props.config.shareUrl}`} target="_blank" rel="noopener noreferrer"> share video </Button>
                    <Button color="primary" variant="contained" size="small" disableElevation className={classes.button} startIcon={<ShareIcon />} onClick={ () => handleShare(props.config.shareUrl)}> share video </Button>
                  }
                </Grid>
              </Grid>
            </div>
          </div>
        </Grid>
      </Grid>
      {
        props.config.finalists &&
        <Collapse in={isOpen}>
          <div className={classes.collapse}>
            {props.config.finalists.map((item, index) =>
              <Finalists config={item} key={index} />
            )}
          </div>
        </Collapse>
      }
    </Paper >
  );
}
